import styled from 'styled-components'

import { colors } from '@/styles'
import TableSortAlphaAsc from './images/table_sort_alpha_asc.svg'
import TableSortAlphaDesc from './images/table_sort_alpha_desc.svg'
import TableSortAsc from './images/table_sort_asc.svg'
import TableSortDesc from './images/table_sort_desc.svg'
import TableHeaderCell from './table-header-cell'

const SortableCell = styled(TableHeaderCell)`
  vertical-align: middle;

  ${props =>
    props.onClick &&
    `
    cursor: pointer;
  `}

  ${props =>
    props.active &&
    `
    background-color: ${colors.secondary};

    p:after {
      content: url(${props.ascending ? TableSortAsc : TableSortDesc});
      display: block;
      margin-left: 5px;

      ${
        props.alpha &&
        `
      content: url(${props.ascending ? TableSortAlphaAsc : TableSortAlphaDesc});
        `
      }
    }
  `}
`

const TableHeaderCellSortable = props => <SortableCell {...props}>{props.children}</SortableCell>

export default TableHeaderCellSortable
